import React from 'react';
import { IGhgEmissionReport } from 'models/ghg-emission-report';
import { emission, percent, TCO2E } from './format';
import GhgComparisonBar from './GhgComparisonBar';
import GhgMetricCard from './GhgMetricCard';

interface GhgOverviewProps {
    report: IGhgEmissionReport;
}

export default function GhgOverview(props: GhgOverviewProps) {
    const report = props.report;

    return (
        <>
            <h3 className="u-fs-18 font-weight-bold mb-1">Teie KHG-heite ülevaade</h3>
            <p className="u-fs-14 ghg-muted mb-4">
                Terminalis tarbitud transpordikütuste ja elektrilaadimise põhjal.
            </p>

            <div className="ghg-metrics mb-4">
                <GhgMetricCard
                    label="Tegelik KHG-heide"
                    value={emission(report.actualEmission)}
                    unit={TCO2E}
                    primary
                />
                <GhgMetricCard
                    label="Välditud KHG-heide"
                    value={emission(report.avoidedEmission)}
                    unit={TCO2E}
                />
                <GhgMetricCard
                    label="Heite vähenemine"
                    value={percent(report.reductionPct) + '%'}
                />
            </div>

            <div className="ghg-compare-head">
                <span className="ghg-compare-head__label">Võrdlus 100% fossiilkütuste kasutamisega</span>
                <span className="ghg-compare-head__ref">
                    Võrdlusheide {emission(report.fossilReference)} {TCO2E}
                </span>
            </div>
            <GhgComparisonBar
                actualShare={report.actualShare}
                reductionPct={report.reductionPct}
                actualLabel="Tegelik KHG-heide"
            />

            <div className="ghg-statement">
                <div className="ghg-statement__big">{percent(report.reductionPct)}% väiksem heide</div>
                <div className="ghg-statement__sub">võrreldes fossiilkütustest pärineva heitega.</div>
            </div>

            {report.showHvoScenario ? (
                <div className="ghg-callout">
                    <h4>HVO ReDiesel</h4>
                    <p className="mb-0">
                        Terminalis tangitav HVO ReDiesel on kasutatud toiduõlist toodetud teise põlvkonna
                        taastuv diislikütus, mis sobib kõikidele diiselmootoritele. Raportis kasutatud
                        heiteväärtuste järgi on selle olelusringi KHG-heide fossiilsest diislikütusest üle
                        90% väiksem, võimaldades vähendada transpordi jalajälge ilma sõidukiparki välja
                        vahetamata.
                    </p>
                </div>
            ) : null}

            <div className="ghg-footnotes">
                <p>
                    Tegelik KHG-heide põhineb kütuste elutsükli heitel (Well-to-Wheel) ning on esitatud
                    detailse ülevaate osas.
                </p>
                <p>
                    Fossiilne võrdlusbaas: {percent(report.fossilBaseline)} gCO<sub>2</sub>e/MJ
                    {' ('}
                    <a
                        href="https://eur-lex.europa.eu/legal-content/ET/TXT/?uri=CELEX%3A32018L2001"
                        target="_blank"
                        rel="noopener noreferrer"
                    >direktiiv (EL) 2018/2001</a>
                    , V lisa C osa p 19).
                </p>
                <p className="mb-0">
                    Elektrilaadimise heide on arvestatud nullina Terminali laadimisvõrgu 100%
                    taastuvelektri alusel.
                </p>
            </div>
        </>
    );
}
